<template>
  <section class="menus-detail-container">
    <div class="tip-header" v-if="form.form.status === 'CHECK_CANCEL'">
      <div class="title">投稿人发起了撤回，请确认是否可以撤回稿件？
        <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="form.form.statusList.length > 0 ? (form.form.statusList[form.form.statusList.length - 1].remark || '暂无') : '暂无'">
          <el-button type="text" slot="reference">查看理由</el-button>
        </el-popover>
      </div>
      <div class="button">
        <el-button type="warn" size="small" width="82px" @click="handleShowMsgDialog(true)">
          同意撤回
        </el-button>
        <el-button type="primary" size="small" width="82px" @click="handleShowMsgDialog(false)">
          不同意撤回
        </el-button>
      </div>
    </div>
    <base-form
      ref="form"
      v-bind="form"
      v-on:handleConfirm="handleConfirm"
    >
      <template #statusList="scope">
        <div class="apis-list-wrap">
          <div class="status-list">
            <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="status-item" :key="index">
                <span class="">
                  <span class="text title">{{checkList.filter(x => x.value === item.type).length == 1 ? checkList.filter(x => x.value === item.type)[0].label : ''}}</span>
                  <span class="text">{{item.createUser ? item.createUser : '暂无'}}</span>
                  <span class="text">{{item.createTime}}</span>
                  <span>
                    <el-button type="default" size="small" width="82px" @click="handleShowDetailDialog(item)">
                      详情查看
                    </el-button>
                  </span>
                </span>
                <span class="status-icon" v-if="index !== scope.form[scope.item.prop].length - 1"><i class="el-icon-right" @click="()=>handleDeleteFile()"></i></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <template #fileList="scope">
        <div class="apis-list-wrap">
          <el-button type="primary" :disabled="scope.form[scope.item.prop].length > 0 ? true : false" size="small" width="82px" @click="handleShowUploadDialog">
            选择文件
          </el-button>
          <div class="apis-list">
            <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index">
                <span>{{item.fileName}}</span>
                <i class="el-icon-close" @click="()=>handleDeleteFile()"></i>
              </span>
            </template>
          </div>
        </div>
      </template>
      <template #time="scope">
        <el-date-picker
          type="date"
          v-model="scope.form[scope.item.prop]"
          placeholder="请输入截止时间"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </template>
      <template #differList="scope">
        <div class="apis-list-wrap">
          <div class="apis-list">
            <template v-for="(item, index) in scope.form.differList1" v-if="scope.form.checkType === 1">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index" @click="()=>handleChooseDiffer(item.label)">
                <span>{{item.label}}</span>
                <!-- <i class="el-icon-close" @click="()=>handleDeleteApi(index)"></i> -->
              </span>
            </template>
            <template v-for="(item, index) in scope.form.differList2" v-if="scope.form.checkType === 2">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index" @click="()=>handleChooseDiffer(item.label)">
                <span>{{item.label}}</span>
                <!-- <i class="el-icon-close" @click="()=>handleDeleteApi(index)"></i> -->
              </span>
            </template>
            <template v-for="(item, index) in scope.form.differList3" v-if="scope.form.checkType === 3">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index" @click="()=>handleChooseDiffer(item.label)">
                <span>{{item.label}}</span>
                <!-- <i class="el-icon-close" @click="()=>handleDeleteApi(index)"></i> -->
              </span>
            </template>
            <!-- <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index" @click="()=>handleChooseDiffer(item.label)">
                <span>{{item.label}}</span>
              </span>
            </template> -->
          </div>
        </div>
      </template>
    </base-form>
    <form-dialog
      title="上传"
      ref="uploadDialog"
      :loading="uploadFormLoading"
      :form="uploadForm"
      :rules="uploadRules"
      :buttons="uploadButtons"
      :formItems="uploadFormItems"
      @handleConfirm="handleConfirmAdd"
      @beforeUpload="beforeUpload"
    ></form-dialog>
    <form-dialog
      title="详情"
      ref="detailDialog"
      :loading="detailFormLoading"
      :form="detailForm"
      :formItems="detailFormItems"
      :buttons="detailButtons"
    >
      <template #attachment="scope">
        <div class="apis-list-wrap">
          <span>{{scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId ? scope.form[scope.item.prop].fileName : '暂无'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button v-if="scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId" type="primary" size="small" width="82px" @click="handleDownload(scope.form[scope.item.prop])">
            点击下载
          </el-button>
        </div>
      </template>
    </form-dialog>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseForm from '@/components/mixins/baseForm'
import formDialog from '@/components/mixins/formDialog'
import msgDialog from '@/components/mixins/msgDialog'

export default {
  name: 'extcontentCheck',
  mixins: [baseHeader, baseForm, msgDialog, formDialog],
  data () {
    const checkList = [
      {
        label: '存为草稿',
        value: 'SAVE_DRAFT'
      },
      {
        label: '投递',
        value: 'POST'
      },
      {
        label: '撤稿',
        value: 'CANCEL'
      },
      {
        label: '取消撤稿',
        value: 'CANCEL_CANCEL'
      },
      {
        label: '删除',
        value: 'DELETE'
      },
      {
        label: '转发给编辑',
        value: 'FORWARD_EDITOR'
      },
      {
        label: '转发给专家',
        value: 'FORWARD_PROFESSOR'
      },
      {
        label: '同意撤稿',
        value: 'AGREE_CANCEL'
      },
      {
        label: '拒绝撤稿',
        value: 'REFUSED_CANCEL'
      },
      {
        label: '录用',
        value: 'OFFER'
      },
      {
        label: '返修',
        value: 'REFUND'
      },
      {
        label: '编辑退稿',
        value: 'CANCELED'
      },
      {
        label: '专家意见: 录用',
        value: 'AGREE'
      },
      {
        label: '专家意见: 返修',
        value: 'DISAGREE'
      },
      {
        label: '专家意见: 退稿',
        value: 'PROFESSOR_CANCEL'
      }
    ]
    return {
      uploadFormLoading: false,
      checkList,
      uploadForm: {
        'fileName': '',
        'file': ''
      },
      uploadRules: {
        fileName: [
          this.$rules.required('请选择需要上传的文件')
        ]
      },
      uploadButtons: [
        {
          text: '确定',
          type: 'Submit'
        }
      ],
      uploadFormItems: [
        {
          prop: 'fileName',
          type: 'upload',
          label: '选择文件',
          readonly: true,
          appendText: '选择文件',
          fileList: [],
          accept: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
      ],
      detailFormLoading: false,
      detailForm: {
        'attachment': {},
        'remark': ''
      },
      detailButtons: [],
      detailFormItems: [
        {
          prop: 'remark',
          type: 'text',
          label: '内容'
        },
        {
          prop: 'attachment',
          type: 'slot',
          label: '附件'
        }
      ],
      form: {
        api: 'fetchExtcontentDetail',
        params: {
          id: ''
        },
        form: {
          id: '',
          checkType: 1,
          fileList: [],
          professor: [],
          time: '',
          usernames: [],
          remark: '',
          remarkText: '',
          differList: [],
          statusList: []
        },
        formItems: [
          {
            prop: 'title',
            label: '稿件名称：',
            type: 'text'
          },
          {
            prop: 'createUser',
            label: '投稿人：',
            type: 'text'
          },
          {
            prop: 'phone',
            label: '电话：',
            type: 'text'
          },
          {
            prop: 'email',
            label: '邮箱：',
            type: 'text'
          },
          {
            prop: 'innovationContent',
            label: '文章创新点：',
            type: 'text'
          },
          {
            prop: 'status',
            label: '状态：',
            type: 'text',
            options: [
              {
                label: '草稿',
                value: 'DRAFT'
              },
              {
                label: '待审核',
                value: 'UNCHECK'
              },
              {
                label: '审核中',
                value: 'CHECKING'
              },
              {
                label: '已撤稿',
                value: 'CANCEL'
              },
              {
                label: '已返修',
                value: 'REFUND'
              },
              {
                label: '已录用',
                value: 'SUCCESS'
              },
              {
                label: '被退稿',
                value: 'CANCELED'
              },
              {
                label: '系统退稿',
                value: 'SYSTEM_CANCELED'
              },
              {
                label: '申请撤稿',
                value: 'CHECK_CANCEL'
              },
              {
                label: '专家审核中',
                value: 'CHECKING_PROFESSOR'
              }
            ]
          },
          {
            prop: 'statusList',
            label: '历史记录：',
            type: 'slot'
          },
          {
            prop: '',
            label: '稿件审核',
            type: 'title'
          },
          {
            type: 'select',
            prop: 'checkType',
            label: '选择操作：',
            options: [
              {
                value: 1,
                label: '录用'
              },
              {
                value: 2,
                label: '返修'
              },
              {
                value: 3,
                label: '退稿'
              },
              {
                value: 4,
                label: '转给编辑'
              },
              {
                value: 5,
                label: '转给专家'
              }
            ]
          },
          {
            prop: 'fileList',
            label: '上传附件：',
            type: 'slot'
          },
          {
            type: 'slot',
            prop: 'differList',
            label: '意见选择：',
            // options: [],
            hidden: (form) => {
              if (form.checkType === 4 || form.checkType === 5) {
                return false
              } else {
                return true
              }
            }
          },
          {
            type: 'checkbox',
            prop: 'professor',
            label: '选择专家：',
            options: [],
            hiddenKey: 'checkType',
            hiddenValue: 5
          },
          {
            type: 'slot',
            prop: 'time',
            label: '截止时间：',
            hiddenKey: 'checkType',
            hiddenValue: 5
          },
          {
            type: 'checkbox',
            prop: 'usernames',
            label: '选择编辑：',
            options: [],
            hiddenKey: 'checkType',
            hiddenValue: 4
          },
          {
            type: 'textarea',
            prop: 'remark',
            label: '审稿意见：',
            maxlength: 2000,
            placeholder: '不超过2000字，您可从下方进行意见选择，选择后可编辑',
            hiddenFunc: (form) => {
              if (form.checkType === 4 || form.checkType === 5) {
                return false
              } else {
                return true
              }
            }
          },
          {
            type: 'textarea',
            prop: 'remarkText',
            label: '备注说明：',
            maxlength: 200,
            placeholder: '不超过200字',
            hiddenFunc: (form) => {
              if (form.checkType === 1 || form.checkType === 2 || form.checkType === 3) {
                return false
              } else {
                return true
              }
            }
          }
        ],
        rules: {
          checkType: [
            this.$rules.required()
          ],
          remark: [
            this.$rules.required()
          ],
          time: [
            this.$rules.required()
          ],
          professor: [
            this.$rules.required()
          ],
          usernames: [
            this.$rules.required()
          ]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          notDisabled: true,
          hidden: (form) => {
            if (form.status === 'CHECK_CANCEL') {
              return false
            } else {
              return true
            }
          }
        }]
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    // 保存提交
    handleConfirm (data) {
      this.form.loading = true
      let api = ''
      let postData = {}
      if (data.checkType === 1) {
        api = 'fetchExtcontentDetailOffer'
        postData = {
          remark: data.remark,
          attachment: data.fileList.length > 0 ? data.fileList[0].file.resourceId : '',
          usernames: [],
          id: data.id
        }
      } else if (data.checkType === 2) {
        api = 'fetchExtcontentDetailBack'
        postData = {
          remark: data.remark,
          attachment: data.fileList.length > 0 ? data.fileList[0].file.resourceId : '',
          usernames: [],
          id: data.id
        }
      } else if (data.checkType === 3) {
        api = 'fetchExtcontentDetailRefuse'
        postData = {
          remark: data.remark,
          attachment: data.fileList.length > 0 ? data.fileList[0].file.resourceId : '',
          usernames: [],
          id: data.id
        }
      } else if (data.checkType === 4) {
        api = 'fetchExtcontentDetailForwardEditor'
        postData = {
          remark: data.remarkText,
          attachment: data.fileList.length > 0 ? data.fileList[0].file.resourceId : '',
          usernames: data.usernames,
          id: data.id
        }
      } else if (data.checkType === 5) {
        api = 'fetchExtcontentDetailForwardProfessor'
        postData = {
          remark: data.remarkText,
          attachment: data.fileList.length > 0 ? data.fileList[0].file.resourceId : '',
          usernames: data.professor,
          endTime: data.time,
          id: data.id
        }
        if (data.fileList.length === 0) {
          this.$message({
            message: '请上传附件',
            type: 'error'
          })
          this.hideFormLoading()
          return false
        }
      }
      this.$request[api](postData).then(res => {
        this.hideFormLoading()
        if (res.code === 200) {
          this.$refs.form.resetFields()
          this.removeTab(this.$route.fullPath)
          this.$router.replace({ name: 'extcontentListIndex' })
        }
      }).catch(this.hideFormLoading)
    },
    fetchFormCallBack (res) {
      if (res.code === 200) {
        res.data.hidden = !res.data.hidden
        this.$set(this.form, 'form', {
          checkType: 1,
          usernames: [],
          differList: this.form.form.differList1,
          differList1: this.form.form.differList1,
          differList2: this.form.form.differList2,
          differList3: this.form.form.differList3,
          fileList: [],
          professor: [],
          statusList: res.data.details,
          ...res.data,
          remark: ''
        })
      }
    },
    fetchExtcontentSetList () {
      this.$request.fetchExtcontentSetList2({ queryType: 'POST' }).then(res => {
        if (res.code === 200) {
          let arr = []
          if (res.data instanceof Array) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].content
              })
            }
          }
          this.form.form.differList1 = arr
        }
      })
      this.$request.fetchExtcontentSetList2({ queryType: 'CANCELED' }).then(res => {
        if (res.code === 200) {
          let arr = []
          if (res.data instanceof Array) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].content
              })
            }
          }
          this.form.form.differList2 = arr
        }
      })
      this.$request.fetchExtcontentSetList2({ queryType: 'REFUND' }).then(res => {
        if (res.code === 200) {
          let arr = []
          if (res.data instanceof Array) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].content
              })
            }
          }
          this.form.form.differList3 = arr
        }
      })
    },
    fetchExtcontentEditorList () {
      let data = {
        page: 1,
        size: 100,
        roleid: 424
      }
      this.$request.fetchExtcontentEditorList(data).then(res => {
        if (res.code === 200) {
          let arr = []
          if (res.data.content instanceof Array) {
            for (let i = 0; i < res.data.content.length; i++) {
              arr.push({
                value: res.data.content[i].id,
                label: res.data.content[i].userExt.realname || res.data.content[i].username
              })
            }
          }
          this.form.formItems.filter(d => d.prop === 'usernames')[0].options = arr
        }
      })
    },
    fetchExtcontentProfessorList () {
      let data = {
        page: 1,
        size: 100,
        roleid: 426
      }
      this.$request.fetchExtcontentProfessorList(data).then(res => {
        if (res.code === 200) {
          let arr = []
          if (res.data.content instanceof Array) {
            for (let i = 0; i < res.data.content.length; i++) {
              arr.push({
                value: res.data.content[i].id,
                label: res.data.content[i].userExt.realname || res.data.content[i].username
              })
            }
          }
          this.form.formItems.filter(d => d.prop === 'professor')[0].options = arr
        }
      })
    },
    handleShowUploadDialog () {
      this.$refs.uploadDialog.showDialog()
    },
    // 上传
    beforeUpload (file, type) {
      this.uploadForm.fileName = file.name
      this.uploadForm.file = file
      this.uploadForm.type = type
    },
    handleConfirmAdd (data, btn) {
      const param = new FormData() // 创建form对象
      param.append('uploadFile', data.file.raw, data.fileName) // 通过append向form对象添加数据
      // param.append('spaceId', this.list.params.id) // 添加form表单中其他数据
      // param.append('typeStr', data.type) // 添加form表单中其他数据
      // param.append('addToRes', true) // 添加form表单中其他数据
      this.$request.fetchUpload(param).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          let arr = []
          arr.push({
            origName: res.data.origName,
            fileName: data.fileName,
            file: res.data
          })
          this.form.form.fileList = arr
        }
      })
    },
    handleChooseDiffer (val) {
      this.form.form.remark = val
    },
    handleDeleteFile () {
      this.form.form.fileList = []
    },
    handleShowDetailDialog (data) {
      this.detailForm = {
        attachment: {
          fileName: data.attachmentName,
          fileId: data.attachment
        },
        remark: data.remark
      }
      let arr = ['POST', 'FORWARD_EDITOR', 'FORWARD_PROFESSOR', 'CANCEL']
      let arr2 = ['OFFER', 'REFUND', 'CANCELED', 'AGREE', 'DISAGREE', 'PROFESSOR_CANCEL']
      if (arr.indexOf(data.type) !== -1) {
        this.detailFormItems[0].label = '备注说明'
      } else if (arr2.indexOf(data.type) !== -1) {
        this.detailFormItems[0].label = '审稿意见'
      } else {
        this.detailFormItems[0].label = '内容'
      }
      this.$refs.detailDialog.showDialog()
    },
    handleDownload (data, btn) {
      console.log(data)
      // 下载
      var ids = [data.fileId]
      this.$request.resourceSpaceDatasDownload({ ids: ids }).then(res => {
        this.$exportClick(res, data.fileName)
      })
    },
    handleShowMsgDialog (isTrue) {
      if (isTrue) {
        this.msgDialog.type = 'Agree'
        this.msgDialog.content = '确定同意撤回吗？'
      } else {
        this.msgDialog.type = 'Refused'
        this.msgDialog.content = '确定不同意撤回吗？'
      }
      this.showMsgDialog()
    },
    // 弹出框操作按钮
    handleConfirmMsg (type) {
      switch (type) {
        case 'Agree':
          this.fetchExtcontentDetailAgree(this.form.form.id)
          break
        case 'Refused':
          this.fetchExtcontentDetailRefused(this.form.form.id)
          break
      }
    },
    fetchExtcontentDetailAgree (id) {
      var params = {
        id: id
      }
      this.$request.fetchExtcontentDetailAgree(params).then(res => {
        if (res.code === 200) {
          this.fetchFormApi()
          this.$router.replace({ name: 'extcontentListIndex' })
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      })
    },
    fetchExtcontentDetailRefused (id) {
      var params = {
        id: id
      }
      this.$request.fetchExtcontentDetailRefused(params).then(res => {
        if (res.code === 200) {
          this.fetchFormApi()
          this.$router.replace({ name: 'extcontentListIndex' })
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      })
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.form.params.id = id
    this.fetchFormApi()
    this.fetchExtcontentSetList()
    this.fetchExtcontentEditorList()
    this.fetchExtcontentProfessorList()
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.form.params.id = id
      this.fetchFormApi()
    }
    this.fetchExtcontentSetList()
    this.fetchExtcontentEditorList()
    this.fetchExtcontentProfessorList()
  }
}
</script>
<style lang="scss" scoped>
.menus-detail-container{
  .apis-list{
    color: #666666;
    display: flex;
    flex-direction: column;
    width: 414px;
    .api-item{
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 22px;
      padding: 10px 30px 10px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      margin-top: 10px;
      position: relative;
      span {
        word-break: break-all;
      }
      span:last-of-type{
        flex: 1;
      }
      i{
        cursor: pointer;
        position: absolute;
        right: 10px;
      }
    }
  }
  .status-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: solid 1px #e5e5e5;
    .status-item {
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      span {
        display: block;
        text-align: left;
      }
      .text {
        line-height: 26px;
        color:#5f5d5d;
      }
      .title {
        color: #000;
      }
    }
    .status-icon {
      margin-left: 20px;
    }
  }
  .tip-header {
    height: 40px;
    background:#f2fbfc;
    border:1px solid #1fc6df;
    border-radius:4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-right: 40px;
    margin-bottom: 40px;
    box-sizing: border-box;
    .title {
      font-size:14px;
      color:#000000;
    }
    .button {

    }
  }
}
</style>
